export class mdlPayFortRequestDetailsReq{
    public ProposalNo: string;
    public PaymentMethod: string;
    public Email_Id: string;
    public Language: string;
    public RegNo: string;
    public ProductCode: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlPayFortRequestDetailsReq.ts